import React from "react";
import ContentsEn from "../components/pages/join/en/Contents";
import HeaderEn from "../components/header/en/Header";

const Join = () => {
  return (
    <>
      <HeaderEn />
      <ContentsEn />
    </>
  );
};

export default Join;
